<template>
    <div>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <template v-slot:action="{ row }">
                <PoptipButton
                    v-if="$can('delete')"
                    text="删除"
                    transfer
                    type="default"
                    title="确认删除该条记录?"
                    :ok="() => { rowConfirmDel(row) }"
                ></PoptipButton>
            </template>
        </Table>
    </div>
</template>
<script>
import FormOrderConsult from './form-order-consult'
import { pipeCell } from '_c/grid/renderCell'
import { viewOrderConsult, msgDelete } from '@/api/order-manage'
const PAGE_SIZE = 20

export default {
    name: 'FormOrderWaitInfo',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            mtHeight: 520,
            loading: false,
            page: {
                list: []
            }
        }
    },

    computed: {
        columns() {
            let that = this
            return [
                {
                    key: 'sendUsername',
                    title: '对话人',
                    align: 'left',
                    minWidth: 80
                },
                {
                    key: 'createTime',
                    title: '对话时间',
                    align: 'left',
                    minWidth: 100,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'content',
                    title: '对话内容',
                    align: 'left',
                    minWidth: 280,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 90,
                    slot: 'action'
                }
            ]
        }
    },

    methods: {
        fetch() {
            this.loading = true
            return viewOrderConsult(this.id)
                .then(res => {
                    this.setPageData(res.data)
                })
                .finally(() => (this.loading = false))
        },
        setPageData(data) {
            let list = data.list
            list.forEach(el => {
                let className =
                    el.sponsor == '1' ? 'consult-sponsor' : 'consult-answer'
                el.cellClassName = {
                    sendUsername: className,
                    createTime: className,
                    content: className
                }
                // 处理【】【】【content】格式的消息
                el.content = el.content ? (el.content.split("【")[3] || "").split("】")[0] : ""
            })
            this.page.list = list
        },
        rowConfirmDel(row) {
            this.loading = true
            msgDelete(row.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    },

    mounted() {
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()]).finally(() => {
                next()
            })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
